import { render, staticRenderFns } from "./vipTab.vue?vue&type=template&id=51da38d2&scoped=true&"
import script from "./vipTab.vue?vue&type=script&lang=ts&"
export * from "./vipTab.vue?vue&type=script&lang=ts&"
import style0 from "./vipTab.vue?vue&type=style&index=0&id=51da38d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51da38d2",
  null
  
)

export default component.exports